var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _circle2, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _circle3, _rect21, _rect22, _circle4, _rect23, _rect24, _circle5, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreen01Dashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 780",
    width: 360,
    height: 780,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 780,
    fill: "#0c1218"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 19,
    width: 18,
    height: 8,
    rx: 2,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 19,
    width: 14,
    height: 8,
    rx: 2,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 18,
    width: 20,
    height: 10,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 12,
    width: 100,
    height: 24,
    rx: 12,
    fill: "#000",
    opacity: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 56,
    width: 70,
    height: 7,
    rx: 3.5,
    fill: "#4b5a68",
    opacity: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 72,
    width: 150,
    height: 16,
    rx: 8,
    fill: "#dfe6e8",
    opacity: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 70,
    r: 18,
    fill: "#2c7f86",
    opacity: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 66,
    r: 7,
    fill: "#5ce1e6",
    opacity: 0.9
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 112,
    width: 320,
    height: 150,
    rx: 18,
    fill: "#141d27",
    opacity: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 132,
    width: 80,
    height: 7,
    rx: 3.5,
    fill: "#4b5a68",
    opacity: 1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 150,
    width: 150,
    height: 30,
    rx: 8,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 196,
    width: 280,
    height: 10,
    rx: 5,
    fill: "#233142",
    opacity: 1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 196,
    width: 207.2,
    height: 10,
    rx: 5,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 222,
    width: 40,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 236,
    width: 60,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 222,
    width: 40,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 236,
    width: 60,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 222,
    width: 40,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 236,
    width: 60,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 278,
    width: 100,
    height: 70,
    rx: 14,
    fill: "#141d27",
    opacity: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 300,
    r: 10,
    fill: "#5ce1e6",
    opacity: 0.25
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 322,
    width: 60,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 278,
    width: 100,
    height: 70,
    rx: 14,
    fill: "#141d27",
    opacity: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 300,
    r: 10,
    fill: "#5ce1e6",
    opacity: 0.5
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 322,
    width: 60,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 278,
    width: 100,
    height: 70,
    rx: 14,
    fill: "#141d27",
    opacity: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 300,
    r: 10,
    fill: "#5ce1e6",
    opacity: 0.75
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 322,
    width: 60,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 364,
    width: 320,
    height: 170,
    rx: 18,
    fill: "#141d27",
    opacity: 1
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 384,
    width: 90,
    height: 8,
    rx: 4,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 417,
    width: 14,
    height: 93,
    rx: 4,
    fill: "#34424f",
    opacity: 1
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 457,
    width: 14,
    height: 53,
    rx: 4,
    fill: "#34424f",
    opacity: 1
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 436,
    width: 14,
    height: 74,
    rx: 4,
    fill: "#34424f",
    opacity: 1
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 422,
    width: 14,
    height: 88,
    rx: 4,
    fill: "#34424f",
    opacity: 1
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 425,
    width: 14,
    height: 85,
    rx: 4,
    fill: "#34424f",
    opacity: 1
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 473,
    width: 14,
    height: 37,
    rx: 4,
    fill: "#34424f",
    opacity: 1
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 479,
    width: 14,
    height: 31,
    rx: 4,
    fill: "#34424f",
    opacity: 1
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 440,
    width: 14,
    height: 70,
    rx: 4,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 429,
    width: 14,
    height: 81,
    rx: 4,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 409,
    width: 14,
    height: 101,
    rx: 4,
    fill: "#34424f",
    opacity: 1
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 412,
    width: 14,
    height: 98,
    rx: 4,
    fill: "#34424f",
    opacity: 1
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 402,
    width: 14,
    height: 108,
    rx: 4,
    fill: "#34424f",
    opacity: 1
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 552,
    width: 320,
    height: 54,
    rx: 14,
    fill: "#141d27",
    opacity: 1
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 564,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#2c7f86",
    opacity: 1
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 568,
    width: 140,
    height: 8,
    rx: 4,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 584,
    width: 90,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 572,
    width: 50,
    height: 10,
    rx: 5,
    fill: "#5ce1e6",
    opacity: 0.9
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 616,
    width: 320,
    height: 54,
    rx: 14,
    fill: "#141d27",
    opacity: 1
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 628,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#2c7f86",
    opacity: 1
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 632,
    width: 140,
    height: 8,
    rx: 4,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 648,
    width: 90,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 636,
    width: 50,
    height: 10,
    rx: 5,
    fill: "#5ce1e6",
    opacity: 0.9
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 696,
    width: 360,
    height: 84,
    rx: 0,
    fill: "#141d27",
    opacity: 1
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 716,
    width: 22,
    height: 22,
    rx: 6,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 744,
    width: 28,
    height: 5,
    rx: 2.5,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 716,
    width: 22,
    height: 22,
    rx: 6,
    fill: "#4b5a68",
    opacity: 1
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 744,
    width: 28,
    height: 5,
    rx: 2.5,
    fill: "#34424f",
    opacity: 1
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 716,
    width: 22,
    height: 22,
    rx: 6,
    fill: "#4b5a68",
    opacity: 1
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 744,
    width: 28,
    height: 5,
    rx: 2.5,
    fill: "#34424f",
    opacity: 1
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 716,
    width: 22,
    height: 22,
    rx: 6,
    fill: "#4b5a68",
    opacity: 1
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 744,
    width: 28,
    height: 5,
    rx: 2.5,
    fill: "#34424f",
    opacity: 1
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 716,
    width: 22,
    height: 22,
    rx: 6,
    fill: "#4b5a68",
    opacity: 1
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 744,
    width: 28,
    height: 5,
    rx: 2.5,
    fill: "#34424f",
    opacity: 1
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 766,
    width: 120,
    height: 5,
    rx: 2.5,
    fill: "#dfe6e8",
    opacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen01Dashboard);
export default __webpack_public_path__ + "static/media/screen-01-dashboard.4fa0569d8757e9005f104d5d819245f6.svg";
export { ForwardRef as ReactComponent };